import {
    COLOR_OPTIONS,
    MUNSELL_CODE_OPTIONS,
    MUNSELL_CODE_LABELS
} from '@ast-data/shared';
import RepeaterList from '../../components/RepeaterList';
import VocabSuggestField from './VocabSuggestField';
import { munsellToHex } from './munsellColor';
import type { ColorRow } from './colorRows';

// ---------------------------------------------------------------------------
/**
 * The Farbe/Munsell list editor, shared by the Planum and Profil forms.
 *
 * A matrix often shows several colours, so this is a list rather than a pair of
 * fields — see RepeaterList for the list itself; only the two fields of a row
 * are written here.
 */
// ---------------------------------------------------------------------------

export default function ColorListEditor({
    rows,
    onChange
}: {
    rows: ColorRow[];
    onChange: (rows: ColorRow[]) => void;
}) {
    return (
        <RepeaterList
            rows={rows}
            onChange={onChange}
            blankRow={{ color: '', munsellCode: '' }}
            labelId="planum.field.colors"
            emptyId="planum.color.empty"
            addId="planum.color.add"
            removeId="planum.color.remove"
            renderRow={(row, update) => (
                <>
                    <VocabSuggestField
                        value={row.color}
                        onChange={(color) => update({ color })}
                        options={COLOR_OPTIONS}
                        labelId="planum.field.color"
                    />
                    <VocabSuggestField
                        value={row.munsellCode}
                        onChange={(munsellCode) => update({ munsellCode })}
                        options={MUNSELL_CODE_OPTIONS}
                        labelId="planum.field.munsellCode"
                        hints={MUNSELL_CODE_LABELS}
                        dotFor={munsellToHex}
                    />
                </>
            )}
        />
    );
}
